/* eslint-disable react/react-in-jsx-scope */
import {
  BaSeButton,
  BaSeInput,
  BaSeParagraph,
  BaSeSmall1,
  BaSeTextArea,
  BaSeTheme,
} from '@base/react';
import {
  AlignContent,
  AlignRow,
  AlignRowColumn,
} from './form-question-confirm-style';
import React from 'react';

// import { Container } from './styles';

function FormQuestionConfirm({
  respostasQuestionarioStartup,
  avaliar,
  hasApprove,
}) {
  return (
    <AlignContent>
      <AlignRowColumn>
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
          Estágio da startup:
        </BaSeParagraph>
        <BaSeSmall1>
          {respostasQuestionarioStartup?.answers?.startupStage}
        </BaSeSmall1>
      </AlignRowColumn>

      <AlignRow>
        <BaSeInput
          label="Nome da startup:"
          width={'50%'}
          value={respostasQuestionarioStartup?.answers?.startupName}
          isReadOnly
        />
        <BaSeInput
          width={'25%'}
          label="Ano fundação:"
          value={
            respostasQuestionarioStartup?.answers?.fundationYear === 0
              ? ''
              : respostasQuestionarioStartup?.answers?.fundationYear
          }
          isReadOnly
        />
        <BaSeInput
          isReadOnly
          width={'25%'}
          label="CNPJ:"
          value={respostasQuestionarioStartup?.answers?.cnpj}
        />
      </AlignRow>

      <AlignRow>
        <AlignRowColumn style={{ width: '50%' }}>
          <BaSeInput
            isReadOnly
            label="Site:"
            value={respostasQuestionarioStartup?.answers?.site}
          />
          <BaSeInput
            isReadOnly
            label="Instagram:"
            value={respostasQuestionarioStartup?.answers?.instagram}
          />
          <AlignRow>
            <BaSeInput
              isReadOnly
              label="Nº colaboradores:"
              value={
                respostasQuestionarioStartup?.answers?.numberOfColaborations ===
                  0
                  ? ''
                  : respostasQuestionarioStartup?.answers?.numberOfColaborations
              }
            />
            <BaSeInput
              label="Vínculo com a startup:"
              value={respostasQuestionarioStartup?.answers?.startupBond}
            />
          </AlignRow>
        </AlignRowColumn>
        <div style={{ width: '50%' }}>
          <BaSeTextArea
            hasCounter={hasApprove ? 'words' : null}
            placeholder=""
            onChange={(value) => { }}
            rows={8}
            textSize="medium"
            value={respostasQuestionarioStartup?.answers?.solvedAndProposed}
            label="Qual problema sua startup resolve e qual a sua proposta de solução?"
          />
        </div>
      </AlignRow>

      <AlignRowColumn>
        <div>
          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
            Sinalize seus diferenciais no ambiente startup:
          </BaSeParagraph>
        </div>
        {(respostasQuestionarioStartup?.answers?.differences ?? []).map((it) => (
          <BaSeSmall1 key={it}>{it}</BaSeSmall1>
        ))}
      </AlignRowColumn>



      {hasApprove && (
        <div
          style={{
            display: 'flex',
            gap: 12,
            marginLeft: 'auto',
          }}
        >
          <BaSeButton
            type="secondary"
            color="#F5CE60"
            onClick={() => avaliar('REPROVADO')}
            value="- Reprovar"
          />
          <BaSeButton
            onClick={() => avaliar('APROVADO')}
            value="+ Aprovar"
            color="#463B1B"
          />
        </div>
      )}
    </AlignContent>
  );
}

export default FormQuestionConfirm;
